import { ReactNode } from 'react';
import {
  ContentActionsProvider,
  IContentActionsType,
} from '../../../../hooks/Contexts/useContentActionsContext';

interface IContentActionRootProps {
  children: ReactNode;
  className?: string;

  contentId?: string;
  contentSlug?: string;
  contentType: IContentActionsType;
}

export function ContentActionRoot({
  children,
  className,
  contentType,
  contentSlug,
  contentId,
}: IContentActionRootProps) {
  return (
    <ContentActionsProvider
      contentId={contentId}
      contentSlug={contentSlug}
      contentType={contentType}
    >
      <div className={`flex gap-lg ${className}`}>{children}</div>
    </ContentActionsProvider>
  );
}
